import React from "react";

const INPUT_SHADOW =
  "0 1px 2px rgba(15, 23, 42, 0.05), 0 1px 3px rgba(15, 23, 42, 0.03)";

const resultFormStyles = {
  page: {
    minHeight: "100vh",
    width: "100%",
    background: "transparent",
    paddingBottom: 88,
    position: "relative",
    zIndex: 1,
    boxSizing: "border-box",
  },
  pageInner: {
    width: "100%",
    maxWidth: "100%",
    margin: 0,
    padding: "20px 12px 32px",
    boxSizing: "border-box",
  },
  header: {
    margin: "0 0 12px",
    padding: "2px 0 6px",
    display: "flex",
    alignItems: "center",
    gap: 12,
    flexWrap: "wrap",
  },
  backBtn: {
    flexShrink: 0,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 40,
    height: 40,
    border: "1px solid #e5e7eb",
    borderRadius: 12,
    background: "#ffffff",
    color: "#334155",
    cursor: "pointer",
    boxShadow: "0 2px 8px rgba(15, 23, 42, 0.1)",
  },
  titleBlock: { flex: "1 1 220px", minWidth: 0 },
  title: { margin: 0, fontSize: 22, fontWeight: 700, color: "#1f2937" },
  subtitle: { margin: "4px 0 0", fontSize: 13, color: "#64748b" },
  formStack: {
    display: "flex",
    flexDirection: "column",
    gap: 20,
  },
  section: {
    margin: 0,
    borderRadius: 14,
    overflow: "hidden",
    border: "1px solid #e8edf2",
    backgroundColor: "#ffffff",
    boxShadow: "0 2px 12px rgba(15, 23, 42, 0.06)",
  },
  sectionBody: {
    padding: "14px 16px 16px",
  },
  fieldsGridRow: {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    gap: 12,
    marginBottom: 12,
  },
  fieldBlock: {
    display: "flex",
    flexDirection: "column",
    gap: 6,
    minWidth: 0,
  },
  fieldLabel: {
    margin: 0,
    fontSize: 12,
    fontWeight: 600,
    color: "#475569",
    letterSpacing: "0.02em",
  },
  labeledRow: {
    display: "grid",
    gridTemplateColumns: "minmax(150px, 30%) 1fr",
    gap: "10px 14px",
    alignItems: "center",
    marginBottom: 12,
  },
  labeledRowTop: {
    alignItems: "start",
  },
  labeledRowLabel: {
    margin: 0,
    fontSize: 13,
    fontWeight: 600,
    color: "#475569",
    textAlign: "right",
    lineHeight: 1.35,
  },
  actionsCard: {
    margin: 0,
    borderRadius: 14,
    border: "1px solid #e8edf2",
    backgroundColor: "#ffffff",
    padding: "14px 16px",
    boxShadow: "0 2px 12px rgba(15, 23, 42, 0.06)",
  },
  sectionHeaderBase: {
    padding: "12px 16px",
    color: "#ffffff",
    fontWeight: 700,
    fontSize: 15,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    flexWrap: "wrap",
  },
  historialChip: {
    padding: "6px 12px",
    borderRadius: 999,
    background: "rgba(255,255,255,0.22)",
    color: "#ffffff",
    fontSize: 12,
    fontWeight: 600,
    border: "1px solid rgba(255,255,255,0.4)",
    cursor: "pointer",
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
  },
  docsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(5, minmax(0, 1fr))",
    gap: 14,
  },
  docSlot: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    minWidth: 0,
    padding: 14,
    borderRadius: 12,
    border: "1px solid #e8edf2",
    backgroundColor: "#f8fafc",
    boxShadow: INPUT_SHADOW,
  },
  docSlotLabel: {
    margin: 0,
    fontSize: 12,
    fontWeight: 600,
    color: "#475569",
    lineHeight: 1.35,
    wordBreak: "break-word",
  },
  statusChipGroup: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
    padding: "4px 0 8px",
  },
  statusChipHint: {
    margin: 0,
    fontSize: 13,
    fontWeight: 600,
    color: "#64748b",
  },
  statusChipRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: 10,
    alignItems: "center",
  },
  statusChipEmpty: {
    margin: 0,
    fontSize: 12,
    color: "#94a3b8",
    fontStyle: "italic",
  },
  rechazoPanel: {
    marginTop: 16,
    padding: "16px 18px",
    borderRadius: 12,
    border: "1px solid #fecaca",
    backgroundColor: "#fffbfb",
    display: "flex",
    flexDirection: "column",
    gap: 16,
    boxShadow: INPUT_SHADOW,
  },
  rechazoPanelTitle: {
    margin: 0,
    fontSize: 14,
    fontWeight: 700,
    color: "#991b1b",
  },
  reasonChipRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: 8,
    alignItems: "center",
  },
};

const ENTREVISTADO_STATUS_OPTIONS = ["Aceptado", "Rechazado", "Cartera"];

function getReasonChipButtonStyle(selected) {
  return {
    padding: "8px 16px",
    borderRadius: 999,
    border: `2px solid ${selected ? "#dc2626" : "#e2e8f0"}`,
    background: selected ? "#dc2626" : "#ffffff",
    color: selected ? "#ffffff" : "#475569",
    fontSize: 13,
    fontWeight: 600,
    cursor: "pointer",
    boxShadow: selected
      ? "0 2px 6px rgba(220, 38, 38, 0.2)"
      : INPUT_SHADOW,
    transition: "background 0.15s ease, border-color 0.15s ease, color 0.15s ease",
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    maxWidth: "100%",
    textAlign: "left",
  };
}

function getStatusChipButtonStyle(statusName, selected) {
  const palette = {
    Aceptado: {
      color: "#3d7a42",
      bg: "#f0fdf4",
      border: "#b8e6ba",
      activeBg: "#72B56F",
    },
    Rechazado: {
      color: "#b91c1c",
      bg: "#fef2f2",
      border: "#fca5a5",
      activeBg: "#dc2626",
    },
    Cartera: {
      color: "#475569",
      bg: "#f8fafc",
      border: "#cbd5e1",
      activeBg: "#64748b",
    },
  };
  const c = palette[statusName] || palette.Cartera;

  return {
    padding: "10px 22px",
    borderRadius: 999,
    border: `2px solid ${selected ? c.activeBg : c.border}`,
    background: selected ? c.activeBg : c.bg,
    color: selected ? "#ffffff" : c.color,
    fontSize: 14,
    fontWeight: 700,
    cursor: "pointer",
    boxShadow: selected
      ? "0 2px 8px rgba(15, 23, 42, 0.12)"
      : INPUT_SHADOW,
    transition: "background 0.15s ease, border-color 0.15s ease, color 0.15s ease",
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
  };
}

function getStatusHeaderGradient(statusName) {
  const map = {
    Solicitado: "linear-gradient(135deg, #50B7C0 0%, #3d9aa3 100%)",
    Entrevistado: "linear-gradient(135deg, #F5D76E 0%, #E0B020 100%)",
    Aceptado: "linear-gradient(135deg, #72B56F 0%, #5D9E5A 100%)",
    "Entrevista con Lider":
      "linear-gradient(135deg, #1E90FF 0%, #1565c0 100%)",
    "Pre-Colaborador":
      "linear-gradient(135deg, #FFA500 0%, #e69500 100%)",
    Rechazado: "linear-gradient(135deg, #dc2626 0%, #991b1b 100%)",
    Cartera: "linear-gradient(135deg, #64748b 0%, #475569 100%)",
  };
  return (
    map[statusName] ||
    "linear-gradient(135deg, #50B7C0 0%, #3d9aa3 100%)"
  );
}

function getStatusAccentColor(statusName) {
  const map = {
    Solicitado: "#50B7C0",
    Entrevistado: "#E0B020",
    Aceptado: "#72B56F",
    "Entrevista con Lider": "#1E90FF",
    "Pre-Colaborador": "#FFA500",
    Rechazado: "#dc2626",
    Cartera: "#64748b",
  };
  return map[statusName] || "#50B7C0";
}

function getWorkDayChipStyle(active, statusName) {
  const accent = getStatusAccentColor(statusName);
  return {
    width: 52,
    height: 52,
    borderRadius: 999,
    padding: 0,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 12,
    fontWeight: 600,
    border: `2px solid ${active ? accent : "#e2e8f0"}`,
    background: active ? accent : "#ffffff",
    color: active ? "#ffffff" : "#94a3b8",
    opacity: active ? 1 : 0.65,
    boxShadow: active
      ? `0 2px 6px ${accent}40`
      : "0 1px 2px rgba(15, 23, 42, 0.05)",
    cursor: "default",
  };
}

function getStatusBadgeStyle(statusName) {
  const map = {
    Solicitado: { color: "#2d8a93", bg: "#e8f7f8", border: "#a5e8ec" },
    Entrevistado: { color: "#7a6200", bg: "#fffbeb", border: "#F5D76E" },
    Aceptado: { color: "#3d7a42", bg: "#eef7ee", border: "#b8e6ba" },
    "Entrevista con Lider": {
      color: "#0369a1",
      bg: "#ecfeff",
      border: "#a5f3fc",
    },
    "Pre-Colaborador": {
      color: "#ffffff",
      bg: "#FFA500",
      border: "#FFA500",
    },
    Rechazado: { color: "#b91c1c", bg: "#fef2f2", border: "#fecaca" },
    Cartera: { color: "#475569", bg: "#f8fafc", border: "#e2e8f0" },
  };
  const c = map[statusName] || map.Solicitado;
  return {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "8px 18px",
    borderRadius: 999,
    fontSize: 14,
    fontWeight: 700,
    lineHeight: 1.2,
    letterSpacing: "0.02em",
    color: c.color,
    backgroundColor: c.bg,
    border: `1.5px solid ${c.border}`,
    flexShrink: 0,
    minHeight: 36,
  };
}

function ResultSection({ children, style, className = "" }) {
  const sectionClass = ["result-form-section", className].filter(Boolean).join(" ");
  return (
    <div
      className={sectionClass}
      style={{ ...resultFormStyles.section, ...style }}
    >
      {children}
    </div>
  );
}

function ResultSectionHeader({ children, statusName = "" }) {
  return (
    <div
      style={{
        ...resultFormStyles.sectionHeaderBase,
        background: getStatusHeaderGradient(statusName),
      }}
    >
      {children}
    </div>
  );
}

function ResultSectionBody({ children }) {
  return <div style={resultFormStyles.sectionBody}>{children}</div>;
}

function getControlStyle(disabled) {
  return {
    height: 44,
    borderRadius: 10,
    border: "1px solid #e2e8f0",
    fontSize: 14,
    width: "100%",
    boxSizing: "border-box",
    padding: "0 12px",
    backgroundColor: disabled ? "#f8fafc" : "#ffffff",
    color: disabled ? "#64748b" : "#1f2937",
    boxShadow: INPUT_SHADOW,
  };
}

function getFileInputStyle() {
  return {
    width: "100%",
    maxWidth: "100%",
    fontSize: 12,
    borderRadius: 10,
    border: "1px solid #e2e8f0",
    padding: "8px 10px",
    backgroundColor: "#ffffff",
    color: "#64748b",
    boxShadow: INPUT_SHADOW,
    cursor: "pointer",
    boxSizing: "border-box",
  };
}

function getTextareaStyle(disabled) {
  return {
    ...getControlStyle(disabled),
    height: "auto",
    minHeight: 88,
    padding: "10px 12px",
    resize: "vertical",
    lineHeight: 1.45,
  };
}

function ResultFormUiStyles() {
  return (
    <style>{`
      .result-form-ui.result-form-stack fieldset {
        border: none;
        padding: 0;
        margin: 0;
        min-width: 0;
        display: flex;
        flex-direction: column;
        gap: 20px;
      }
      .result-form-ui .form-control:focus,
      .result-form-ui .form-select:focus,
      .result-form-ui textarea:focus {
        border-color: #50B7C0 !important;
        box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05),
          0 0 0 3px rgba(80, 183, 192, 0.2) !important;
        outline: none;
      }
      .result-form-ui textarea.result-form-input-like {
        height: 44px !important;
        min-height: 44px !important;
        padding: 10px 12px !important;
        line-height: 22px !important;
        resize: none;
        overflow-y: auto;
      }
      .result-form-ui .result-form-file-input::file-selector-button {
        margin-right: 10px;
        padding: 6px 12px;
        border: none;
        border-radius: 8px;
        background: #50b7c0;
        color: #ffffff;
        font-size: 12px;
        font-weight: 600;
        cursor: pointer;
      }
      .result-form-ui .result-form-file-input::file-selector-button:hover {
        background: #3d9aa3;
      }
      @media (max-width: 1200px) {
        .result-form-ui .result-form-docs-grid {
          grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
        }
      }
      @media (max-width: 767px) {
        .result-form-ui .result-form-docs-grid {
          grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
        }
      }
      @media (max-width: 480px) {
        .result-form-ui .result-form-docs-grid {
          grid-template-columns: 1fr !important;
        }
      }
      @media (max-width: 991px) {
        .result-form-ui .result-form-fields-row {
          grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
        }
      }
      @media (max-width: 767px) {
        .result-form-ui .result-form-fields-row {
          grid-template-columns: 1fr !important;
        }
        .result-form-ui .result-form-labeled-row {
          grid-template-columns: 1fr !important;
        }
        .result-form-ui .result-form-labeled-row b {
          text-align: left !important;
        }
        .result-form-ui .result-form-status-chips {
          flex-direction: column;
          align-items: stretch !important;
        }
        .result-form-ui .result-form-status-chip {
          width: 100%;
          justify-content: center;
        }
      }
      .result-form-ui .result-form-status-chip:hover {
        filter: brightness(0.97);
      }
      .result-form-ui .result-form-status-chip:focus-visible {
        outline: none;
        box-shadow: 0 0 0 3px rgba(80, 183, 192, 0.35) !important;
      }
      .result-form-ui .result-form-reason-chip:hover {
        filter: brightness(0.98);
      }
      .result-form-ui .result-form-reason-chip:focus-visible {
        outline: none;
        box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.25) !important;
      }
      @media (max-width: 767px) {
        .result-form-ui .result-form-reason-chips {
          flex-direction: column;
          align-items: stretch !important;
        }
        .result-form-ui .result-form-reason-chip {
          width: 100%;
          justify-content: center;
        }
      }
    `}</style>
  );
}

export {
  resultFormStyles,
  ENTREVISTADO_STATUS_OPTIONS,
  getReasonChipButtonStyle,
  getStatusChipButtonStyle,
  getStatusHeaderGradient,
  getStatusAccentColor,
  getWorkDayChipStyle,
  getStatusBadgeStyle,
  ResultSection,
  ResultSectionHeader,
  ResultSectionBody,
  getControlStyle,
  getFileInputStyle,
  getTextareaStyle,
  ResultFormUiStyles,
};
